import React, { useState, useEffect } from "react";

import "../styles/Design.css";

export default function Design() {
  const images = [
    "Technical Image 1.png",
    "Technical Image 2.png",
    "Technical Image 3.png",
    "Technical Image 4.png",
    "Technical Image 5.png",
    "Technical Image 6.png",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isHovered, images.length]);

  return (
    <div className="design-container">
      <div className="design-header">
        <div className="header-text">
          <h1>Charles Timmins: Redefining Waterproof Swimwear</h1>
          <p>
            At Charles Timmins, we combine premium design with cutting-edge
            innovative technology to create swimwear that protects your
            valuables. Our unique ziplock waterproof seal ensures 100%
            watertight protection up to 5 meters, while the double heat-welded
            rubber pocket guarantees superior durability and performance.
            Rigorously tested for reliability, our swimwear gives you the
            freedom to enjoy every adventure worry-free.
          </p>
        </div>
        <div
          className="image-container"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src={`Technical Images/${images[currentImageIndex]}`}
            alt={`Slide ${currentImageIndex + 1}`}
            className="carousel-image"
          />
        </div>
      </div>
      <section className="two-columns">
        <div className="column">
          <h2>We Care About Your Valuables</h2>
          <p>
            When it comes to keeping your valuables safe and dry while enjoying
            your time in the water, trust is key. At CT, we understand the
            importance of providing our customers with swimwear they can rely
            on, which is why our waterproof pockets are designed to offer the
            ultimate peace of mind.
          </p>
        </div>
        <div className="column">
          <h2>Tested & Trusted</h2>
          <p>
            While producing our products they undergo extensive testing to
            verify their waterproof performance. From submersion tests to
            pressure tests, we leave no room for doubt when it comes to the
            reliability of the pockets.
          </p>
        </div>
      </section>
    </div>
  );
}
